import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import { SchoolConfig } from '../types/schoolConfigType';
import httpPost from './httpClient/httpPost';

const getSchoolConfig = async (school: string) =>
  httpGet(`${envVar.REACT_APP_BASE_API_URL}/schools/${school}/config`);

const getSchoolClassesConfig = async (school: string) =>
  httpGet(`${envVar.REACT_APP_BASE_API_URL}/config/${school}`);

const updateSchoolConfig = async (
  school: string,
  config: Partial<SchoolConfig>
) =>
  httpPost(`${envVar.REACT_APP_BASE_API_URL}/schools/${school}/config`, config);

export { getSchoolConfig, getSchoolClassesConfig, updateSchoolConfig };
